module.exports = __webpack_public_path__ + "img/acc_carousel_07.fd417d14.jpg";